import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import modules_eaa8372d from './CircularProgress.module.css.mjs';

const BASE_SIZE = 44;
/**
 * A lightweight spinning circle loading animation heavily inspired by the
 * MUI CircularProgress component
 * https://github.com/mui/material-ui/blob/master/packages/mui-material/src/CircularProgress/CircularProgress.js
 */ const CircularProgress = ({ size, label, thickness = 3.6 })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: modules_eaa8372d.root,
        style: {
            width: size,
            height: size
        }
    }, /*#__PURE__*/ React__default.createElement("svg", {
        className: modules_eaa8372d.svg,
        viewBox: `${BASE_SIZE / 2} ${BASE_SIZE / 2} ${BASE_SIZE} ${BASE_SIZE}`,
        "aria-label": label ?? $__i18n._({
            id: "loading.label"
        })
    }, /*#__PURE__*/ React__default.createElement("circle", {
        className: modules_eaa8372d.animatedCircle,
        cx: BASE_SIZE,
        cy: BASE_SIZE,
        r: (BASE_SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
};

export { CircularProgress };
//# sourceMappingURL=CircularProgress.mjs.map
